module.exports = __webpack_public_path__ + "media/newstyle/images/icon-speak-purple-d510c55318c7091b514c5679404cbb0e.svg";